import { supabase } from '@/lib/supabase';

interface UpdatePasswordParams {
  currentPassword?: string;
  newPassword: string;
}

export const updatePassword = async ({
  currentPassword,
  newPassword,
}: UpdatePasswordParams) => {
  // Verify current password only when provided (Settings flow)
  if (currentPassword) {
    const {
      data: { user },
    } = await supabase.auth.getUser();

    if (!user?.email) {
      throw new Error('User email not found');
    }

    const { error: signInError } = await supabase.auth.signInWithPassword({
      email: user.email,
      password: currentPassword,
    });

    if (signInError) {
      throw new Error('current_password_incorrect');
    }
  }

  // Update to the new password
  const { data, error } = await supabase.auth.updateUser({
    password: newPassword,
  });
  if (error) {
    throw error;
  }
  return data;
};
